import $ from "jquery"

const contains = $.contains
const unwrap = (element) => {
  const contents = $(element).contents()
  $(element).replaceWith(contents)
}
export const toArray = Array.from

export default class AnnotationsDOMManager {
  container = null
  counter = 0
  elementName = "mark"
  wrapperIdAttribute = "data-id"
  wrappersSelector = `${this.elementName}[${this.wrapperIdAttribute}]`
  settings = {
    onSelectionEnd: undefined,
    onSelectionClick: undefined,
    onSelectionRightClick: undefined,
    onSelectionMouseEnter: undefined,
    onSelectionMouseLeave: undefined,
    makeId: () => this.counter++,
    containerClassName: "",
    wrapperClassName: "",
    activeClassName: "",
    editable: true,
  }

  initialize = (container, settings) => {
    this.container = container
    settings && this.setSettings(settings)

    this.settings.containerClassName &&
      this.container.classList.add(this.settings.containerClassName)
    this.container.addEventListener("mouseup", this.onMouseUp)

    const wrappers = toArray(this.getWrappers())
    wrappers.forEach(this.initWrapper)
    return wrappers.map(this.getWrapperId)
  }

  destroy = () => {
    const wrappers = this.getWrappers()
    toArray(wrappers).forEach(this.toggleWrapperHandlers(false))

    this.container.removeEventListener("mouseup", this.onMouseUp)
  }

  setSettings = (settings) => Object.assign(this.settings, settings)

  setContainerClassName(containerClassName) {
    if (containerClassName !== undefined) {
      this.settings.containerClassName &&
        this.container.classList.remove(this.settings.containerClassName)
      containerClassName && this.container.classList.add(containerClassName)
      Object.assign(this.settings, { containerClassName })
    }
  }

  makeWrapper = () => {
    const wrapper = document.createElement(this.elementName)
    this.initWrapper(wrapper)
    return wrapper
  }
  initWrapper = (wrapper) => {
    this.settings.wrapperClassName && wrapper.classList.add(this.settings.wrapperClassName)
    !this.getWrapperId(wrapper) &&
      wrapper.setAttribute(this.wrapperIdAttribute, this.settings.makeId())
    this.toggleWrapperHandlers(true)(wrapper)
  }
  reInitWrappersHandlers = () => {
    const wrappers = this.getWrappers()
    toArray(wrappers).forEach(this.toggleWrapperHandlers(false))
    toArray(wrappers).forEach(this.toggleWrapperHandlers(true))
  }
  toggleWrapperHandlers = (flag) => (wrapper) => {
    const action = flag ? "addEventListener" : "removeEventListener"
    wrapper[action]("click", this.handleWrapperClick)
    wrapper[action]("mouseup", this.handleWrapperMouseUp)
    wrapper[action]("mouseenter", this.handleWrapperMouseEnter)
    wrapper[action]("mouseleave", this.handleWrapperMouseLeave)
    wrapper[action]("contextmenu", this.handleWrapperRightClick)
  }
  removeWrapper = (id) => {
    const wrapper = this.getWrapperById(id)
    return wrapper && (unwrap(wrapper), id)
  }
  removeWrappers = (ids) => ids.forEach(this.removeWrapper)
  setActiveWrapper = (id) => {
    const wrapper = this.getWrapperById(id)
    this.deactivateWrappers()
    wrapper && wrapper.classList.add(this.settings.activeClassName)
  }
  deactivateWrappers = () => {
    toArray(this.getWrappers()).forEach((wrapper) =>
      wrapper.classList.remove(this.settings.activeClassName),
    )
  }
  getWrapperId = (wrapper) => wrapper.getAttribute(this.wrapperIdAttribute)
  getWrapperById = (id) =>
    this.container.querySelector(`${this.elementName}[${this.wrapperIdAttribute}="${id}"]`)
  getWrappers = () => this.container.querySelectorAll(this.wrappersSelector) || []

  handleWrapperClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (this.settings.onSelectionClick) {
      this.settings.onSelectionClick(e, this.getWrapperId(e.currentTarget))
    }
  }
  handleWrapperMouseUp = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
  handleWrapperRightClick = (e) => {
    if (this.settings.onSelectionRightClick) {
      this.settings.onSelectionRightClick(e, this.getWrapperId(e.currentTarget))
    }
  }
  handleWrapperMouseEnter = (e) => {
    if (this.settings.onSelectionMouseEnter) {
      this.settings.onSelectionMouseEnter(e, this.getWrapperId(e.currentTarget))
    }
  }
  handleWrapperMouseLeave = (e) => {
    if (this.settings.onSelectionMouseLeave) {
      this.settings.onSelectionMouseLeave(e, this.getWrapperId(e.currentTarget))
    }
  }

  getRange = (selection) => window.getSelection().getRangeAt(0)
  wrapRange = (wrapper, range) => {
    const contents = range.extractContents()
    wrapper.appendChild(contents)
    range.insertNode(wrapper)
  }

  isSelectionValid = (selection) => {
    if (selection.toString().trim() === "") {
      return false
    }

    const range = this.getRange(selection)
    const wrappers = this.getWrappers()
    if (
      range.cloneContents().querySelector(this.wrappersSelector) ||
      toArray(wrappers).some((x) => contains(x, selection.focusNode)) ||
      toArray(wrappers).some((x) => contains(x, selection.anchorNode))
    ) {
      return false
    }

    if (
      !contains(this.container, selection.focusNode) ||
      !contains(this.container, selection.anchorNode)
    ) {
      return false
    }

    if (
      selection.focusNode.nodeType === Node.TEXT_NODE &&
      selection.anchorNode.nodeType === Node.TEXT_NODE &&
      selection.focusNode.parentElement !== selection.anchorNode.parentElement
    ) {
      return false
    }

    if (
      selection.focusNode.nodeType !== Node.TEXT_NODE &&
      selection.anchorNode.nodeType !== Node.TEXT_NODE &&
      selection.focusNode !== selection.anchorNode
    ) {
      return false
    }

    return true
  }

  isLeftButtonClick = (e) => e.which === 1
  onMouseUp = (e) => {
    if (!this.settings.editable) return
    if (!this.isLeftButtonClick(e)) return
    if (!this.isSelectionValid(window.getSelection())) return

    const wrapper = this.makeWrapper()
    const range = this.getRange()

    this.wrapRange(wrapper, range)
    if (this.settings.onSelectionEnd) {
      this.settings.onSelectionEnd(e, wrapper, this.getWrapperId(wrapper))
    }
  }
}
